// extracted by mini-css-extract-plugin
export default {"container":"SidebarItem_container__OV16S","iconContainer":"SidebarItem_iconContainer__0qXM2","group":"SidebarItem_group__mGO3c"};